module.exports = __webpack_public_path__ + "static/104-c184fb6264864dc08c1ae55817d28e00.png";